import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const MesinkasirPage = () => (
  <Layout>
    <SEO title="Mesin Kasir" />
    <div class="masthead-followup row m-3">
<div class="col-12 col-md-12 p-3 p-md-5 bg-white text-center">
  <h1><strong><a title="new mesin kasir" href="/mesinkasir">MESIN KASIR</a></strong></h1>
  <h2>Paket lengkap mesin kasir point of sale set siap pakai.</h2>
  <div class="embed-responsive embed-responsive-21by9">
  <iframe title="mesin kasir" width="560" height="315" src="https://www.youtube.com/embed/NJ7mrZ__pOE" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div>
    <p>Mesin kasir set paket lengkap modern up to date untuk menunjang berbagai bidang bisnis dan usaha dalam kebutuhan point of sale technology yang terintegrasi dengan aplikasi software kasir plus hardware kasir dalam kesatuan POS system <a title="mesin kasir" href="/mesinkasir">mesin kasir lengkap</a> set terbaru.</p>
    <img alt="paket mesin kasir set lengkap murah" width="100%" class="img-fluid shadow" src="./img/mesinkasirmurah (11).jpg"/>
<p>Hybrid portable desain dalam kebutuhan bertransaksi merupakan modern system mesin kasir portable dengan touchscreen metode digunakan semakin sempurna dengan harga yang murah untuk usaha kecil dan menengah, integrasi dengan hardware set alat kasir memudahkan dalam kecepatan transaksi dan pembukuan nya.</p>
<p><a class="button" href="/hybrid">More info</a></p>
<img alt="paket mesin kasir set lengkap" width="100%" class="img-fluid shadow" src="./img/mesin kasir touchscreen (7).jpg"/>
<p>All in one touchscreen metode dalam penggunaan nya slim desain fashionable luxs dan mewah untuk kebutuhan mesin kasir lengkap mu menjadikan kesempurnaan point of sale dalam kebutuhan transaksi dan pembukuan,miliki all in one touchscreen pos ini untuk kebutuhan terbaik mesin kasir set lengap mu.</p>
<p><a class="button" href="/touchscreen">More info</a></p>
<p>List daftar mesin kasir set terbaru up to date untuk digunakan menunjang berbagai usaha dan bisnis mu.</p>
<p>Back to <Link to="/">Home Page</Link></p>
</div></div>
  </Layout>
)

export default MesinkasirPage
